import { useQuery } from "@tanstack/react-query";
import { Post } from "../../../utils/apiService";
import {
  GetADUserByIdBody,
  GetAllAccessGroupsDDBody,
  GetAllAccessLevelsBody,
  GetAllBuildingsBody,
  GetAllBuildingsByIdBody,
  GetAllBuildingsResponse,
  GetAllDepartmentsBody,
  GetAllDepartmentsByIdBody,
  GetAllDynamicWorkflowsBody,
  GetAllDevicesBody,
  GetAllFRDevicesByLocDDBody,
  GetAllDevicesResponse,
  GetAllGatesBody,
  GetAllGatesByIdBody,
  GetAllGatesResponse,
  GetAllLocationsBody,
  GetAllSystemDetailCodesDropdownBody,
  GetAllSystemDetailCodesParams,
  GetAllVisitPurposesBody,
  GetAllVisitPurposesDropdownBody,
  GetBuildingByIdBody,
  GetDepartmentByIdBody,
  GetDynamicWorkflowsByIdBody,
  GetEmailTemplateByIdBody,
  GetFRDeviceByIdBody,
  GetGateByIdBody,
  GetGateByIdResponse,
  GetLocationByIdBody,
  GetAllAccessGroupsBody,
  GetAccessGroupByIdBody,
  GetAccessGroupByIdResponse,
  GetAllMeetingRoomsBody,
  GetAllMeetingRoomsResponse,
  GetAllMeetingRoomsByIdDDBody,
  GetMeetingRoomByIdBody,
  GetAllMusterPointsBody,
  GetMusterPointByIdBody,
} from "../interface";

export const FETCH_COMMON_DETAILS_KEYS = {
  FETCH_ALL_LOCATIONS_DROPDOWN: "FETCH_ALL_LOCATIONS_DROPDOWN",
  FETCH_EMAIL_TEMPLATE_BY_ID: "FETCH_EMAIL_TEMPLATE_BY_ID",
  FETCH_ALL_LOCATIONS: "FETCH_ALL_LOCATIONS",
  FETCH_ALL_GATES: "FETCH_ALL_GATES",
  FETCH_GATE_BY_ID: "FETCH_GATE_BY_ID",
  FETCH_ALL_BUILDINGS: "FETCH_ALL_BUILDINGS",
  FETCH_ALL_DEPARTMENTS: "FETCH_ALL_DEPARTMENTS",
  FETCH_ALL_NATIONALITIES: "FETCH_ALL_NATIONALITIES",
  FETCH_ALL_PLATE_SOURCE: "FETCH_ALL_PLATE_SOURCE",
  FETCH_ALL_STATUSES: "FETCH_ALL_STATUSES",
  FETCH_ALL_DEPARTMENTS_BY_ID: "FETCH_ALL_DEPARTMENTS_BY_ID",
  FETCH_ALL_GATES_BY_ID: "FETCH_ALL_GATES_BY_ID",
  FETCH_ALL_BUILDINGS_BY_ID: "FETCH_ALL_BUILDINGS_BY_ID",
  FETCH_ALL_HOSTS: "FETCH_ALL_HOSTS",
  FETCH_ALL_PLATE_LETTERS: "FETCH_ALL_PLATE_LETTERS",
  FETCH_ALL_PRIVILEGES: "FETCH_ALL_PRIVILEGES",
  FETCH_ALL_ROLES: "FETCH_ALL_ROLES",
  FETCH_ALL_SYSTEM_CODES: "FETCH_ALL_SYSTEM_CODES",
  FETCH_ALL_SYSTEM_DETAIL_CODES: "FETCH_ALL_SYSTEM_DETAIL_CODES",
  FETCH_ALL_VISIT_PURPOSES_DROPDOWN: "FETCH_ALL_VISIT_PURPOSES_DROPDOWN",
  FETCH_ALL_VISIT_PURPOSES: "FETCH_ALL_VISIT_PURPOSES",
  FETCH_ALL_ACCESS_LEVELS: "FETCH_ALL_ACCESS_LEVELS",
  FETCH_ALL_ACCESS_LEVELS_DROPDOWN: "FETCH_ALL_ACCESS_LEVELS_DROPDOWN",
  FETCH_LOCATION_BY_ID: "FETCH_LOCATION_BY_ID",
  FETCH_BUIILDING_BY_ID: "FETCH_BUIILDING_BY_ID",
  FETCH_DEPARTMENTS_BY_ID: "FETCH_DEPARTMENTS_BY_ID",
  FETCH_ALL_EMAIL_CONFIG: "FETCH_ALL_EMAIL_CONFIG",
  FETCH_ALL_DYNAMIC_WORKFLOWS: "FETCH_ALL_DYNAMIC_WORKFLOWS",
  FETCH_DYNAMIC_WORKFLOWS_BY_ID: "FETCH_DYNAMIC_WORKFLOWS_BY_ID",
  FETCH_ACTIVE_DIRECTORY_CONFIG: "FETCH_ACTIVE_DIRECTORY_CONFIG",
  FETCH_ALL_SYSTEM_DETAIL_CODES_DROPDOWN:
    "FETCH_ALL_SYSTEM_DETAIL_CODES_DROPDOWN",
  FETCH_ALL_AD_USERS: "FETCH_ALL_AD_USERS",
  FETCH_AD_USER_BY_ID: "FETCH_AD_USER_BY_ID",
  FETCH_ALL_CRITICAL_NATIONALITIES: "FETCH_ALL_CRITICAL_NATIONALITIES",
  FETCH_ALL_ACCESS_GROUPS_DROPDOWN: "FETCH_ALL_ACCESS_GROUPS_DROPDOWN",
  FETCH_ALL_ACCESS_GROUPS: "FETCH_ALL_ACCESS_GROUPS",
  FETCH_ALL_FR_DEVICES: "FETCH_ALL_FR_DEVICES",
  FETCH_FR_DEVICE_BY_ID: "FETCH_FR_DEVICE_BY_ID",
  FETCH_ALL_FR_DEVICES_BY_LOC_DROPDOWN: "FETCH_ALL_FR_DEVICES_BY_LOC_DROPDOWN",
  FETCH_ALL_FR_DEVICES_DROPDOWN: "FETCH_ALL_FR_DEVICES_DROPDOWN",
  FETCH_ACCESS_GROUP_BY_ID: "FETCH_ACCESS_GROUP_BY_ID",
  FETCH_ALL_MEETING_ROOMS: "FETCH_ALL_MEETING_ROOMS",
  FETCH_ALL_MEETING_ROOMS_BY_ID_DD: "FETCH_ALL_MEETING_ROOMS_BY_ID_DD",
  FETCH_MEETING_ROOM_BY_ID: "FETCH_MEETING_ROOM_BY_ID",
  FETCH_VISITING_HOURS: "FETCH_VISITING_HOURS",
  FETCH_FR_LOG_SERVER_URL: "FETCH_FR_LOG_SERVER_URL",
  FETCH_VALIDATE_PHOTO: "FETCH_VALIDATE_PHOTO",
  FETCH_FR_NTP_SERVER: "FETCH_FR_NTP_SERVER",
  FETCH_FR_DEFAULT_GROUPS: "FETCH_FR_DEFAULT_GROUPS",
  FETCH_FR: "FETCH_FR",
  FETCH_EMAIL_CONFIGS: "FETCH_EMAIL_CONFIGS",
  FETCH_DOCUMENT_ID_TYPES: "FETCH_DOCUMENT_ID_TYPES",
  FETCH_DYNAMIC_WORKFLOWS_BY_ID_BY_NON_ADMIN:
    "FETCH_DYNAMIC_WORKFLOWS_BY_ID_BY_NON_ADMIN",
  FETCH_ALL_PENDING_STATUS_ROLES: "FETCH_ALL_PENDING_STATUS_ROLES",
  FETCH_ALL_MUSTER_POINTS: "FETCH_ALL_MUSTER_POINTS",
  FETCH_MUSTER_POINT_BY_ID: "FETCH_MUSTER_POINT_BY_ID",
  FETCH_EMPLOYEE_DETAILS: "FETCH_EMPLOYEE_DETAILS",
  FETCH_LOCATIONS_WITH_BUILDINGS: "FETCH_LOCATIONS_WITH_BUILDINGS",
  FETCH_ALL_PERMIT_STATUSES: "FETCH_ALL_PERMIT_STATUSES",
  FETCH_FINAL_PERMIT_APPROVAL_RECIPIENTS: "FETCH_FINAL_PERMIT_APPROVAL_RECIPIENTS",
  FETCH_SMS_CONFIG: "FETCH_SMS_CONFIG",
  FETCH_KIOSK_CHECK_IN_FLOW_CONFIG: "FETCH_KIOSK_CHECK_IN_FLOW_CONFIG",
};

const GetKioskCheckInFlowConfigAction = async () => {
  return Post({
    url: "/api/Configs/GetKioskConfig",
  });
};

export const useGetKioskCheckInFlowConfig = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_KIOSK_CHECK_IN_FLOW_CONFIG],
    queryFn: () => GetKioskCheckInFlowConfigAction(),
  });
};

const GetSMSConfigAction = async () => {
  return Post({
    url: "/api/Configs/GetSMSConfig",
  });
};

export const useGetSMSConfig = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_SMS_CONFIG],
    queryFn: () => GetSMSConfigAction(),
  });
};

const GetFinalPermitApprovalRecipientsAction = async () => {
  return Post({
    url: "/api/Email/GetAllFinalPermitApprovalRecipients",
  });
};

export const useGetFinalPermitApprovalRecipients = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_FINAL_PERMIT_APPROVAL_RECIPIENTS],
    queryFn: () => GetFinalPermitApprovalRecipientsAction(),
  });
};

const getLocationsWithBuildingsAction = async () => {
  return Post({
    url: "/api/ParkingEntrySticker/GetLocationsWithBuildings",
  });
};

export const useGetLocationsWithBuildings = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_LOCATIONS_WITH_BUILDINGS],
    queryFn: () => getLocationsWithBuildingsAction(),
  });
};

const getEmployeeDetailsAction = async () => {
  return Post({
    url: "/api/ParkingEntrySticker/GetEmployeeInfo",
  });
};

export const useGetEmployeeDetails = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_EMPLOYEE_DETAILS],
    queryFn: () => getEmployeeDetailsAction(),
  });
};

const getEmailConfigsAction = async () => {
  return Post({
    url: "/api/EmailConfiguration/GetEmailConfigs",
  });
};

export const useGetEmailConfigs = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_EMAIL_CONFIGS],
    queryFn: () => getEmailConfigsAction(),
  });
};

const getValidatePhotoAction = async () => {
  return Post({
    url: "/api/Configs/GetValidatePhotoConfig",
  });
};

export const useGetValidatePhoto = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_VALIDATE_PHOTO],
    queryFn: () => getValidatePhotoAction(),
  });
};

const getFaceRecognitionAction = async () => {
  return Post({
    url: "/api/Configs/GetFaceRecognitionConfig",
  });
};

export const useGetFaceRecognition = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_FR],
    queryFn: () => getFaceRecognitionAction(),
  });
};

const getFRDefaultGroupsAction = async () => {
  return Post({
    url: "/api/Configs/GetFRDefaultGroupsConfig",
  });
};

export const useGetFRDefaultGroups = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_FR_DEFAULT_GROUPS],
    queryFn: () => getFRDefaultGroupsAction(),
  });
};

const getFRNTPServerAction = async () => {
  return Post({
    url: "/api/Configs/GetFRNTPServerConfig",
  });
};

export const useGetFRNTPServer = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_FR_NTP_SERVER],
    queryFn: () => getFRNTPServerAction(),
  });
};

const getFRLogServerUrlAction = async () => {
  return Post({
    url: "/api/Configs/GetFRLogServerUrlConfig",
  });
};

export const useGetFRLogServerUrl = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_FR_LOG_SERVER_URL],
    queryFn: () => getFRLogServerUrlAction(),
  });
};

const getVisitingHoursAction = async () => {
  return Post({
    url: "/api/Configs/GetVisitingHoursConfig",
  });
};

export const useGetVisitingHours = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_VISITING_HOURS],
    queryFn: () => getVisitingHoursAction(),
  });
};

const getAllFRDevicesDDAction = async () => {
  return Post({
    url: "/api/FRDevices/GetAllDropdown",
  });
};

export const useGetAllFRDevicesDD = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_FR_DEVICES_DROPDOWN],
    queryFn: () => getAllFRDevicesDDAction(),
  });
};

const getAllFRDevicesByLocDDAction = async (
  body: GetAllFRDevicesByLocDDBody,
) => {
  return Post({
    url: "/api/FRDevices/GetAllDropdownByLocation",
    body,
  });
};

export const useGetAllFRDevicesByLocDD = (
  body: GetAllFRDevicesByLocDDBody,
  enabled = true,
) => {
  return useQuery({
    queryKey: [
      FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_FR_DEVICES_BY_LOC_DROPDOWN,
      body,
    ],
    queryFn: () => getAllFRDevicesByLocDDAction(body),
    enabled: !!body.encryptedLocationID && !!body.n_BuildingID && enabled,
  });
};

const getAllDevicesAction = async (body: GetAllDevicesBody) => {
  return Post({
    url: "/api/FRDevices/GetAll",
    body,
  });
};

export const useGetAllDevices = (body: GetAllDevicesBody) => {
  return useQuery<GetAllDevicesResponse>({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_FR_DEVICES, body],
    queryFn: () => getAllDevicesAction(body),
  });
};

const getAllAccessGroupsAction = async (body: GetAllAccessGroupsBody) => {
  return Post({
    url: "/api/AccessGroups/GetAll",
    body,
  });
};

export const useGetAllAccessGroups = (body: GetAllAccessGroupsBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_ACCESS_GROUPS, body],
    queryFn: () => getAllAccessGroupsAction(body),
  });
};

const getAllAccessGroupsDDAction = async (body: GetAllAccessGroupsDDBody) => {
  return Post({
    url: "/api/AccessGroups/GetAllDropdownByLocation",
    body,
  });
};

export const useGetAllAccessGroupsDD = (body: GetAllAccessGroupsDDBody) => {
  return useQuery({
    queryKey: [
      FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_ACCESS_GROUPS_DROPDOWN,
      body,
    ],
    queryFn: () => getAllAccessGroupsDDAction(body),
    enabled: !!body.encryptedLocationID && !!body.n_BuildingID,
  });
};

const getAllGatesAction = async (body: GetAllGatesBody) => {
  return Post({
    url: "/api/Gates/GetAll",
    body,
  });
};

export const useGetAllGates = (body: GetAllGatesBody) => {
  return useQuery<GetAllGatesResponse>({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_GATES, body],
    queryFn: () => getAllGatesAction(body),
  });
};

const getAccessGroupByIdAction = async (body: GetAccessGroupByIdBody) => {
  return Post({
    url: "/api/AccessGroups/GetById",
    body,
  });
};

export const useGetAccessGroupById = (body: GetAccessGroupByIdBody) => {
  return useQuery<GetAccessGroupByIdResponse>({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ACCESS_GROUP_BY_ID, body],
    queryFn: () => getAccessGroupByIdAction(body),
    enabled: !!body.encryptedId,
  });
};

const getGateByIdAction = async (body: GetGateByIdBody) => {
  return Post({
    url: "/api/Gates/GetById",
    body,
  });
};

export const useGetGateById = (body: GetGateByIdBody) => {
  return useQuery<GetGateByIdResponse>({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_GATE_BY_ID, body],
    queryFn: () => getGateByIdAction(body),
    enabled: !!body.encryptedId,
  });
};

const getAllLocationsDropdownAction = async () => {
  return Post({
    url: "/api/Locations/GetAllDropdown",
  });
};

export const useGetAllLocationsDropdown = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_LOCATIONS_DROPDOWN],
    queryFn: () => getAllLocationsDropdownAction(),
  });
};

const getAllLocationsAction = async (body: GetAllLocationsBody) => {
  return Post({
    url: "/api/Locations/GetAll",
    body,
  });
};

export const useGetAllLocations = (body: GetAllLocationsBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_LOCATIONS, body],
    queryFn: () => getAllLocationsAction(body),
  });
};

const getAllBuildingsAction = async (body: GetAllBuildingsBody) => {
  return Post({
    url: "/api/Buildings/GetAll",
    body,
  });
};

export const useGetAllBuildings = (body: GetAllBuildingsBody) => {
  return useQuery<GetAllBuildingsResponse>({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_BUILDINGS, body],
    queryFn: () => getAllBuildingsAction(body),
  });
};

const getAllMusterPointsAction = async (body: GetAllMusterPointsBody) => {
  return Post({
    url: "/api/MusterPoints/GetAll",
    body,
  });
};

export const useGetAllMusterPoints = (body: GetAllMusterPointsBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_MUSTER_POINTS, body],
    queryFn: () => getAllMusterPointsAction(body),
  });
};

const getActiveDirectoryConfigAction = async () => {
  return Post({
    url: "/api/Configs/GetActiveDirectoryConfig",
  });
};

export const useGetActiveDirectoryConfig = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ACTIVE_DIRECTORY_CONFIG],
    queryFn: () => getActiveDirectoryConfigAction(),
  });
};

const getAllDynamicWorkflowsAction = async (
  body: GetAllDynamicWorkflowsBody,
) => {
  return Post({
    url: "/api/DynamicWorkFlows/GetAll",
    body,
  });
};

export const useGetAllDynamicWorkflows = (body: GetAllDynamicWorkflowsBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_DYNAMIC_WORKFLOWS, body],
    queryFn: () => getAllDynamicWorkflowsAction(body),
  });
};

const getAllDynamicWorkflowsByIdByNonAdminAction = async (
  body: GetDynamicWorkflowsByIdBody,
) => {
  return Post({
    url: "/api/Appointment/GetDynamicWorkflowRolesById",
    body,
  });
};

export const useGetDynamicWorkflowsByIdByNonAdmin = (
  body: GetDynamicWorkflowsByIdBody,
  enabled = true,
) => {
  return useQuery({
    queryKey: [
      FETCH_COMMON_DETAILS_KEYS.FETCH_DYNAMIC_WORKFLOWS_BY_ID_BY_NON_ADMIN,
      body,
    ],
    queryFn: () => getAllDynamicWorkflowsByIdByNonAdminAction(body),
    enabled: enabled && !!body.encryptedId,
  });
};

const getAllDynamicWorkflowsByIdAction = async (
  body: GetDynamicWorkflowsByIdBody,
) => {
  return Post({
    url: "/api/DynamicWorkFlows/GetById",
    body,
  });
};

export const useGetDynamicWorkflowsById = (
  body: GetDynamicWorkflowsByIdBody,
) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_DYNAMIC_WORKFLOWS_BY_ID, body],
    queryFn: () => getAllDynamicWorkflowsByIdAction(body),
    enabled: !!body.encryptedId,
  });
};

const getAllDepartmentsAction = async (body: GetAllDepartmentsBody) => {
  return Post({
    url: "/api/Departments/GetAll",
    body,
  });
};

export const useGetAllDepartments = (body: GetAllDepartmentsBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_DEPARTMENTS, body],
    queryFn: () => getAllDepartmentsAction(body),
  });
};

const getAllNationalitiesAction = async () => {
  return Post({
    url: "/api/Nationalities/GetAll",
  });
};

export const useGetAllNationalities = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_NATIONALITIES],
    queryFn: () => getAllNationalitiesAction(),
  });
};

const getAllPlateSourceAction = async () => {
  return Post({
    url: "/api/PlateSource/GetAll",
  });
};

export const useGetAllPlateSource = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_PLATE_SOURCE],
    queryFn: () => getAllPlateSourceAction(),
  });
};

const getAllStatusesAction = async () => {
  return Post({
    url: "/api/ApprovalTypes/GetAll",
  });
};

export const useGetAllStatuses = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_STATUSES],
    queryFn: () => getAllStatusesAction(),
  });
};

const getAllPermitStatusesAction = async () => {
  return Post({
    url: "/api/ApprovalTypes/GetAllForPermits",
  });
};

export const useGetAllPermitStatuses = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_PERMIT_STATUSES],
    queryFn: () => getAllPermitStatusesAction(),
  });
};

const getAllDepartmentsByIdAction = async (body: GetAllDepartmentsByIdBody) => {
  return Post({
    url: "/api/Departments/GetByLocation",
    body,
  });
};

export const useGetAllDepartmentsById = (body: GetAllDepartmentsByIdBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_DEPARTMENTS_BY_ID, body],
    queryFn: () => getAllDepartmentsByIdAction(body),
    enabled: !!body.encryptedLocationID && !!body.n_BuildingID,
  });
};

const getAllMeetingRoomsByIdDDAction = async (
  body: GetAllMeetingRoomsByIdDDBody,
) => {
  return Post({
    url: "/api/MeetingRooms/GetAllDropdownByLocation",
    body,
  });
};

export const useGetAllMeetingRoomsByIdDD = (
  body: GetAllMeetingRoomsByIdDDBody,
) => {
  return useQuery({
    queryKey: [
      FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_MEETING_ROOMS_BY_ID_DD,
      body,
    ],
    queryFn: () => getAllMeetingRoomsByIdDDAction(body),
    enabled: !!body.encryptedLocationID && !!body.n_BuildingID,
  });
};

const getAllGatesByIdAction = async (body: GetAllGatesByIdBody) => {
  return Post({
    url: "/api/Gates/GetAllDropdown",
    body,
  });
};

export const useGetAllGatesById = (body: GetAllGatesByIdBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_GATES_BY_ID, body],
    queryFn: () => getAllGatesByIdAction(body),
    enabled: !!body.n_LocationID && !!body.n_BuildingID,
  });
};

const getEmailTemplateByIdAction = async (body: GetEmailTemplateByIdBody) => {
  return Post({
    url: "/api/EmailConfiguration/GetEmailTemplate",
    body,
  });
};

export const useGetEmailTemplateById = (body: GetEmailTemplateByIdBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_EMAIL_TEMPLATE_BY_ID, body],
    queryFn: () => getEmailTemplateByIdAction(body),
    enabled: !!body.EncryptedId,
  });
};

const getAllBuildingsByIdAction = async (body: GetAllBuildingsByIdBody) => {
  return Post({
    url: "/api/Buildings/GetAllDropdown",
    body,
  });
};

export const useGetAllBuildingsById = (body: GetAllBuildingsByIdBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_BUILDINGS_BY_ID, body],
    queryFn: () => getAllBuildingsByIdAction(body),
    enabled: !!body.encryptedId,
  });
};

const getGetAllHostsAction = async () => {
  return Post({
    url: "/api/Hosts/GetAll",
  });
};

export const useGetAllHosts = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_HOSTS],
    queryFn: () => getGetAllHostsAction(),
  });
};

const getAllPlateLettersAction = async () => {
  return Post({
    url: "/api/PlateLetters/GetAll",
  });
};

export const useGetAllPlateLetters = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_PLATE_LETTERS],
    queryFn: () => getAllPlateLettersAction(),
  });
};

const getAllPrivilegesAction = async () => {
  return Post({
    url: "/api/Privileges/GetAll",
  });
};

export const useGetAllPrivileges = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_PRIVILEGES],
    queryFn: () => getAllPrivilegesAction(),
  });
};

const getAllRolesAction = async () => {
  return Post({
    url: "/api/Roles/GetAll",
  });
};

export const useGetAllRoles = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_ROLES],
    queryFn: () => getAllRolesAction(),
  });
};

const getAllPendingStatusRolesAction = async () => {
  return Post({
    url: "/api/Roles/GetAllDashboardRoles",
  });
};

export const useGetAllPendingStatusRoles = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_PENDING_STATUS_ROLES],
    queryFn: () => getAllPendingStatusRolesAction(),
  });
};

const getAllSystemCodesAction = async () => {
  return Post({
    url: "/api/SystemCodes/GetAllMasterCodes",
  });
};

export const useGetAllSystemCodes = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_SYSTEM_CODES],
    queryFn: () => getAllSystemCodesAction(),
  });
};

const getAllSystemDetailCodesAction = async (
  body: GetAllSystemDetailCodesParams,
) => {
  return Post({
    url: "/api/SystemCodes/GetAllDetailCodes",
    body,
  });
};

export const useGetAllSystemDetailCodes = (
  body: GetAllSystemDetailCodesParams,
) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_SYSTEM_DETAIL_CODES, body],
    queryFn: () => getAllSystemDetailCodesAction(body),
    enabled: !!body.encryptedId,
  });
};

const getAllSystemDetailCodesDropdownAction = async (
  body: GetAllSystemDetailCodesDropdownBody,
) => {
  return Post({
    url: "/api/SystemCodes/GetAllDetailCodesDropDown",
    body,
  });
};

export const useGetAllSystemDetailCodesDropdown = (
  body: GetAllSystemDetailCodesDropdownBody,
) => {
  return useQuery({
    queryKey: [
      FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_SYSTEM_DETAIL_CODES_DROPDOWN,
      body,
    ],
    queryFn: () => getAllSystemDetailCodesDropdownAction(body),
    enabled: !!body.encryptedId,
  });
};

const getAllVisitPurposesDropdownAction = async (
  body: GetAllVisitPurposesDropdownBody,
) => {
  return Post({
    url: "/api/VisitPurposes/GetAllDropdown",
    body,
  });
};

export const useGetAllVisitPurposesDropdown = (
  body: GetAllVisitPurposesDropdownBody,
) => {
  return useQuery({
    queryKey: [
      FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_VISIT_PURPOSES_DROPDOWN,
      body,
    ],
    queryFn: () => getAllVisitPurposesDropdownAction(body),
  });
};

const getAllVisitPurposesAction = async (body: GetAllVisitPurposesBody) => {
  return Post({
    url: "/api/VisitPurposes/GetAll",
    body,
  });
};

export const useGetAllVisitPurposes = (body: GetAllVisitPurposesBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_VISIT_PURPOSES, body],
    queryFn: () => getAllVisitPurposesAction(body),
  });
};

const getAllAccessLevelsAction = async (body: GetAllAccessLevelsBody) => {
  return Post({
    url: "/api/AccessLevels/GetAll",
    body,
  });
};

export const useGetAllAccessLevels = (body: GetAllAccessLevelsBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_ACCESS_LEVELS, body],
    queryFn: () => getAllAccessLevelsAction(body),
  });
};

const getAllAccessLevelDropdownAction = async () => {
  return Post({
    url: "/api/AccessLevels/GetAllDropDown",
  });
};

export const useGetAllAccessLevelsDropdown = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_ACCESS_LEVELS_DROPDOWN],
    queryFn: () => getAllAccessLevelDropdownAction(),
  });
};

const getLocationByIdAction = async (body: GetLocationByIdBody) => {
  return Post({
    url: "/api/Locations/GetById",
    body,
  });
};

export const useGetLocationById = (body: GetLocationByIdBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_LOCATION_BY_ID, body],
    queryFn: () => getLocationByIdAction(body),
    enabled: !!body.encryptedId,
  });
};

const getFRDeviceByIdAction = async (body: GetFRDeviceByIdBody) => {
  return Post({
    url: "/api/FRDevices/GetById",
    body,
  });
};

export const useGetFRDeviceById = (body: GetFRDeviceByIdBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_FR_DEVICE_BY_ID, body],
    queryFn: () => getFRDeviceByIdAction(body),
    enabled: !!body.encryptedId,
  });
};

const getBuildingByIdAction = async (body: GetBuildingByIdBody) => {
  return Post({
    url: "/api/Buildings/GetById",
    body,
  });
};

export const useGetBuildingById = (body: GetBuildingByIdBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_BUIILDING_BY_ID, body],
    queryFn: () => getBuildingByIdAction(body),
    enabled: !!body.encryptedId,
  });
};

const getMusterPointByIdAction = async (body: GetMusterPointByIdBody) => {
  return Post({
    url: "/api/MusterPoints/GetById",
    body,
  });
};

export const useGetMusterPointById = (body: GetMusterPointByIdBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_MUSTER_POINT_BY_ID, body],
    queryFn: () => getMusterPointByIdAction(body),
    enabled: !!body.encryptedId,
  });
};

const getMeetingRoomByIdAction = async (body: GetMeetingRoomByIdBody) => {
  return Post({
    url: "/api/MeetingRooms/GetById",
    body,
  });
};

export const useGetMeetingRoomById = (body: GetMeetingRoomByIdBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_MEETING_ROOM_BY_ID, body],
    queryFn: () => getMeetingRoomByIdAction(body),
    enabled: !!body.encryptedId,
  });
};

const getDepartmentByIdAction = async (body: GetDepartmentByIdBody) => {
  return Post({
    url: "/api/Departments/GetById",
    body,
  });
};

export const useGetDepartmentById = (body: GetDepartmentByIdBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_DEPARTMENTS_BY_ID, body],
    queryFn: () => getDepartmentByIdAction(body),
    enabled: !!body.encryptedId,
  });
};

const getAllADUsersAction = async () => {
  return Post({
    url: "/api/ActiveDirectory/GetADUsers",
  });
};

export const useGetAllADUsers = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_AD_USERS],
    queryFn: () => getAllADUsersAction(),
  });
};

const getADUserByIdAction = async (body: GetADUserByIdBody) => {
  return Post({
    url: "/api/ActiveDirectory/GetADUserDetails",
    body,
  });
};

export const useGetADUserById = (body: GetADUserByIdBody) => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_AD_USER_BY_ID, body.encryptedId],
    queryFn: () => getADUserByIdAction(body),
    enabled: !!body.encryptedId,
  });
};

const getAllCriticalNationalitiesAction = async () => {
  return Post({
    url: "/api/CriticalNationalities/GetAll",
  });
};

export const useGetAllCriticalNationalities = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_CRITICAL_NATIONALITIES],
    queryFn: () => getAllCriticalNationalitiesAction(),
  });
};

const getAllMeetingRoomsAction = async (body: GetAllMeetingRoomsBody) => {
  return Post({
    url: "/api/MeetingRooms/GetAll",
    body,
  });
};

export const useGetAllMeetingRooms = (body: GetAllMeetingRoomsBody) => {
  return useQuery<GetAllMeetingRoomsResponse>({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_ALL_MEETING_ROOMS, body],
    queryFn: () => getAllMeetingRoomsAction(body),
  });
};

const getDocumentIDTypesAction = async () => {
  return Post({
    url: "/api/SystemCodes/GetDocumentIDTypes",
  });
};

export const useGetDocumentIDTypes = () => {
  return useQuery({
    queryKey: [FETCH_COMMON_DETAILS_KEYS.FETCH_DOCUMENT_ID_TYPES],
    queryFn: () => getDocumentIDTypesAction(),
  });
};
